import {List} from 'immutable';

export type History<past, future> = {
  past: List<past>;
  future: List<future>;
};

const _emptyHistory = {past: List(), future: List()};

export const emptyHistory = <past, future>() =>
  _emptyHistory as History<past, future>;

export const canUndo = <past, future>(history: History<past, future>) =>
  history.past.size > 0;

export const canRedo = <past, future>(history: History<past, future>) =>
  history.future.size > 0;

export const save =
  (maxSize: number) =>
  <past, future>(history: History<past, future>, item: past) => ({
    past:
      history.past.size < maxSize
        ? history.past.push(item)
        : history.past.shift().push(item),
    future: List<future>(),
  });

export const undo = <past, future>(
  history: History<past, future>,
  item: future
) => ({
  past: history.past.pop(),
  future: history.future.unshift(item),
});

export const redo = <past, future>(
  history: History<past, future>,
  item: past
) => ({
  past: history.past.push(item),
  future: history.future.shift(),
});

export const getMostRecentHistoryItem = <past, future>(
  history: History<past, future>
): null | past => history.past.last() || null;

export const getUpcomingHistoryItem = <past, future>(
  history: History<past, future>
): null | future => history.future.first() || null;
